import React from 'react';
import './login_modal.scss';
import { FormattedMessage } from 'react-intl';
import { Footer } from './components';

import { Modal } from '../components/modal/Modal';
import { ConnectionForm } from './components/connection-form/ConnectionForm';
import { doctrineAnalytics } from '../utils/analyticsUtils';
import { ResetPasswordModal } from './components/reset-password-modal/ResetPasswordModal';

type Props = {
  closeModal: () => void;
  isOpen: boolean;
};

type State = {
  isForgotPasswordStep: boolean;
};

export class LoginModal extends React.Component<Props, State> {
  static defaultProps = {
    closeModal: () => {},
    isOpen: false,
  };

  state: State = {
    isForgotPasswordStep: false,
  };

  switchToForgotPassword = () => {
    doctrineAnalytics('Account ModalResetPasswordAppeared');
    this.setState(({ isForgotPasswordStep }) => ({
      isForgotPasswordStep: !isForgotPasswordStep,
    }));
  };

  render() {
    const { isOpen, closeModal } = this.props;
    const { isForgotPasswordStep } = this.state;

    return (
      <>
        {!isForgotPasswordStep && (
          <Modal isOpen={isOpen} onRequestClose={closeModal}>
            <div className="modal" data-test-id="login-modal">
              <>
                <i
                  className="modal__close"
                  aria-hidden="true"
                  onClick={closeModal}
                />
                <div className="modal__container login-modal">
                  <h2 className="modal__title--big">
                    <FormattedMessage id="login/LoginModal.tsx/1" />
                  </h2>
                  <ConnectionForm
                    switchToForgotPassword={this.switchToForgotPassword}
                  />
                  <Footer />
                </div>
              </>
            </div>
          </Modal>
        )}
        {isForgotPasswordStep && (
          <ResetPasswordModal
            isOpen={isOpen}
            closeModal={closeModal}
            data-test-id="forgot-modal"
          />
        )}
      </>
    );
  }
}
